// extracted by mini-css-extract-plugin
export default {"myBtn":"MyButton_myBtn__8Pp5Z","green":"MyButton_green__KLuoE MyButton_myBtn__8Pp5Z","red":"MyButton_red__I3nLD MyButton_myBtn__8Pp5Z"};